import { getData, postData, putData, deleteData } from "../apiClient";

export const getPagesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), search });
        // The API route is mounted at /pages, so we access /pages/
        const result = await getData(`/pages/?${queryParams}`, {}, {}, signal);
        return { success: true, ...result };
    } catch (error) {
        console.error("Get Pages pagination API error:", error);
        return { success: false, ...error };
    }
};

// Fetch a page by its slug
export const getPageBySlug = async (slug) => {
    return await getData(`pages/${slug}`);
};

export const getPageDataWithId = async (id) => {
    try {
        const result = await getData(`/pages/detail/${id}`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get Page by ID API error:", error);
        return { data: { success: false, error: error.message } };
    }
};

export const createPage = async (data) => {
    try {
        const result = await postData(`/pages/create`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Create Page API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.data?.error || error.data?.message : error.message, status: error.status } };
    }
};

export const updatePage = async ({ id, data }) => {
    try {
        const result = await putData(`/pages/update/${id}`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Update Page API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.data?.error || error.data?.message : error.message, status: error.status } };
    }
};

export const deletePage = async ({ id }) => {
    try {
        const result = await deleteData(`/pages/delete/${id}`);
        return { data: { success: true, data: result } };
    } catch (error) {
        console.error("Delete Page API error:", error);
        return { data: { success: false, error: error.status === 400 ? error.error : error.message, status: error.status } };
    }
};
